var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abk-survey-form',{attrs:{"submit-action":_vm.createSurvey,"validate-action":_vm.validate,"survey-id":this.$route.query.copy_id,"new-survey":""}})}
var staticRenderFns = []

export { render, staticRenderFns }